
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/radce",
      function () {
        return require("private-next-pages/radce/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/radce"])
      });
    }
  